import React from "react";
import { Typography, Tooltip } from "@material-ui/core";

const ANCHOS_VALIDOS = [33, 50, 66, 100];

const OPCIONES_ANCHO = [
  { v: 33, short: "33%", hint: "Un tercio del ancho útil (p. ej. junto a otro bloque más ancho)" },
  { v: 50, short: "MITAD DE ANCHO", hint: "Mitad del ancho útil" },
  { v: 66, short: "66%", hint: "Dos tercios del ancho útil" },
  { v: 100, short: "ANCHO COMPLETO", hint: "Todo el ancho útil de la sección" },
];

/**
 * Misma herramienta visual que en comités: ancho en rejilla 12 cols de la web de congresos.
 */
export default function CongresoSeccionAnchoGrillaEditor({
  value,
  onChange,
  disabled = false,
  label = "Ancho en la web de congresos",
  compact = false,
}) {
  const n = Number(value);
  const current = ANCHOS_VALIDOS.includes(n) ? n : 100;

  return (
    <div className={compact ? "congreso-edicion-item-ancho-wrap mb-2" : "congreso-edicion-programa-ancho-wrap mb-4"}>
      <Typography
        variant="caption"
        color="textSecondary"
        display="block"
        className={compact ? "mb-0" : "mb-1"}
        style={compact ? { fontSize: "0.7rem" } : undefined}
      >
        {label}
      </Typography>
      <div className="congreso-edicion-comite-ancho-rail" role="radiogroup" aria-label={label}>
        {OPCIONES_ANCHO.map(({ v, short, hint }) => {
          const active = current === v;
          return (
            <Tooltip key={v} title={hint}>
              <button
                type="button"
                className={`congreso-edicion-comite-ancho-seg${active ? " is-selected" : ""}`}
                aria-pressed={active}
                disabled={disabled}
                onClick={() => !disabled && onChange(v)}
              >
                <span className="congreso-edicion-comite-ancho-seg__bar-wrap" aria-hidden>
                  <span
                    className={`congreso-edicion-comite-ancho-bar congreso-edicion-comite-ancho-bar--a${v}`}
                  />
                </span>
                <span className="congreso-edicion-comite-ancho-seg__label">{short}</span>
              </button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}
